<template>
    <div
        class="@container/mh-sidebar flex-1 min-h-0 max-h-full flex flex-col overflow-clip rounded-2xl border-x-0 border-t-0 border-b border-b-white md:bg-slate-300/30 md:shadow-[inset_0px_2px_4px_0px_rgba(0,0,0,0.06)] md:border-solid"
    >
        <div class="scroll-thin flex-auto overflow-auto">
            <div class="flex flex-col p-4 gap-4">
                <intelligent-inbox-section
                    v-for="section in sections"
                    :key="section.sectionValue"
                    :section="section"
                    :loadingCategories="loadingCategories"
                    :loadingCounts="loadingCounts"
                    :sectionCount="sectionCounts[section.sectionValue] ?? 0"
                    :categoryCounts="categoryCounts[section.sectionValue] ?? {}"
                ></intelligent-inbox-section>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { onMounted, onUnmounted } from 'vue';
import IntelligentInboxSection from './IntelligentInboxSection.vue';
import { useIntelligentInbox } from './useIntelligentInbox';
import { useCurrentGroup } from '~/composables/useCurrentGroup';
import Bus from '~/globals/eventBus';
import type { Thread } from '~/services/threads/threadsClient.types';

const { getContext } = useCurrentGroup();

const {
    sections,
    loadingCategories,
    loadingCounts,
    fetchCategories,
    fetchCounts,
    sectionCounts,
    categoryCounts,
    refreshCounts,
} = useIntelligentInbox();

const handleEchoThreadUpdated = ({ thread }: { thread: Thread }): void => {
    Bus.$emit('threadUpdated', { thread });
};

const handleBusThreadUpdated = (): void => {
    refreshCounts();
};

// eslint-disable-next-line no-undef
let echoChannel: EchoChannel;

onMounted(() => {
    const { teamId, orgUnitId, groupId } = getContext();
    const channelName =
        !orgUnitId && !groupId
            ? `messages.${teamId}`
            : orgUnitId
            ? `messages.${teamId}.org_unit.${orgUnitId}`
            : `messages.${teamId}.${groupId}`;
    echoChannel = window.Echo.private(channelName);
    echoChannel.listen('.ThreadUpdated', handleEchoThreadUpdated);
    Bus.$on('threadUpdated', handleBusThreadUpdated);

    fetchCategories();
    fetchCounts();
});

onUnmounted(() => {
    echoChannel?.stopListening('.ThreadUpdated', handleEchoThreadUpdated);
    Bus.$off('threadUpdated', handleBusThreadUpdated);
});
</script>

<style>
@keyframes inbox-blink {
    0%,
    100% {
        background-color: rgb(255 255 255 / 0.5);
    }
    50% {
        background-color: rgb(255 255 255 / 1);
    }
}
.animate-inbox-blink {
    animation: inbox-blink 0.6s ease-in-out 2;
}
</style>
